// extracted by mini-css-extract-plugin
module.exports = {"image":"_1410bfd27b--image--gv_W_"};